export default __webpack_public_path__ + "d5f43fa5db29d84fe005171e733cac3d.png";